import { doc, updateDoc } from "firebase/firestore"
import { db } from "../Firebase/Config"

export const updateData = async (collectionName, docId, data)=> {
    const res = await updateDoc(doc(db, collectionName, docId), data)
    return res
}